import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

export const ShipmentTable = (props) => {
  return (
    <table className="table table-striped table-bordered datatable mb-0">
      <thead>
        <tr>
          <th>Id</th>
          <th className="hidden-xs-down">Date</th>
          <th>Destination</th>
          <th className="hidden-xxs-down">Status</th>
          <th className="hidden-xs-down">User</th>
          <th>Actions</th>
        </tr>
      </thead>
      <ShipmentList shipments={props.list}/>
    </table>
  )
};

export const EmptyTable = () => {
  return (
    <div className="shipment-list--empty">
      <div className="fa fa-truck icon" aria-hidden="true"></div>
      <div>No shipments yet</div>
    </div>
  )
};

const ShipmentTableRow = (props) => {
    let date = props.shipment ? moment(props.shipment.creation_date).format('L') : '';
    return(
      <tr>
        <td>{props.shipment ? props.shipment.id : ''}</td>
        <td className="hidden-xs-down">{date}</td>
        <td>{props.shipment.destination.name}</td>
        <td className="hidden-xxs-down">
          <span className={`badge badge-pill ${props.shipment.status === 'In Progress' ?
                'badge-warning': 'badge-success'}`}>{props.shipment.status}</span>
        </td>
        <td className="hidden-xs-down">{props.shipment.user}</td>
        <td>
          <span  className="d-flex">
            {props.shipment.status === 'In Progress'?
              <NavLink to={`/shipment/${props.shipment.id}/edit`} className="btn-sm btn-info">
                <i className="fa fa-edit"></i>
              </NavLink>
              :
              <span className="d-flex">
                <NavLink to={`/shipment/${props.shipment.id}`} className="btn-sm btn-info">
                  <i className="fa fa-eye"></i>
                </NavLink>
                <NavLink className="ml-05 btn-sm btn-danger" to={`/return/new/?s=${props.shipment.id}`}>
                  <i className="fa fa-arrow-left"></i>
                </NavLink>
              </span>
            }
          </span>
        </td>
      </tr>
    )
};

export default class ShipmentList extends Component {
  render() {
    return (
      <tbody>
        {this.props.shipments.map((s,idx) => {
            return <ShipmentTableRow shipment={s} key={idx}/>
          })
        }
      </tbody>
    );
  }
};
